const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://tdpccc-api.cgis.asia/",
  },
  production: {
    api: "https://tdpccc-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
